import React from 'react';
import styled from 'styled-components';
import { makeColorSetClass, cssSpacing, } from '@spotify-internal/encore-web';
import { ImageAspectBox21x9, Grid, ContentfulImage, TWO_COLUMN_MAX_WIDTH, SectionHeader, } from '../../ui';
import { Quote } from './Quote';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
const SingleTestimonial = styled(Grid) `
  padding-top: ${cssSpacing('looser-2')};
  padding-bottom: ${cssSpacing('looser-3')};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-bottom: ${cssSpacing('looser-2')};
  }
`;
const ImageContainer = styled(ImageAspectBox21x9) `
  grid-column: 1 / -1;

  margin-bottom: ${cssSpacing('looser-2')};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    order: 2;
  }
`;
const HeadlineSupertextBody = styled.div `
  grid-column: 1 / 5;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 1;
  }
`;
const StyledTestimonial = styled.div `
  grid-column: 6 / -1;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
    order: 3;
  }
`;
export const SingleTestimonialModule = React.forwardRef(({ supertext = '', headline = '', body = '', quote = '', image, source = '', jobTitle = '', caption = '', theme = '', colors, }, ref) => {
    const quoteProps = {
        quote,
        source,
        jobTitle,
    };
    const useColors = (colors === null || colors === void 0 ? void 0 : colors.backgroundColor) && colors.textColor;
    return (React.createElement(ColorSetWrapper, { colors: colors },
        React.createElement(SingleTestimonial, { ref: ref, className: !useColors
                ? makeColorSetClass(theme === 'whiteOnBlack' ? 'base' : 'invertedDark')
                : '' },
            image && (React.createElement(ImageContainer, null,
                React.createElement(ContentfulImage, { asset: image, caption: caption }))),
            React.createElement(HeadlineSupertextBody, null,
                React.createElement(SectionHeader, { eyebrow: supertext, heading: headline, body: body })),
            React.createElement(StyledTestimonial, null,
                React.createElement(Quote, { ...quoteProps })))));
});
